import script from "./BookingConfirmationRegisteredUser.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingConfirmationRegisteredUser.vue?vue&type=script&setup=true&lang=js"

import "./BookingConfirmationRegisteredUser.vue?vue&type=style&index=0&id=1a3289a9&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a3289a9"]])

export default __exports__